import {gql} from "@apollo/client";

const MarketplaceUnreadCountQuery = gql`
    query MarketplaceUnreadCount($marketplaceSlug: String) {
        marketplaceUnreadMessageCount(marketplaceSlug: $marketplaceSlug)
    }
`;

export default MarketplaceUnreadCountQuery;
